/* import __COLOCATED_TEMPLATE__ from './ticket-type-row.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import type InboxSidebarService from 'embercom/services/inbox-sidebar-service';
import type Conversation from 'embercom/objects/inbox/conversation';
import type { TicketType } from 'embercom/objects/inbox/ticket';

interface Args {
  ticketType?: TicketType;
  conversation?: Conversation;
  labelRowSize?: string;
  setTicketTypeToChangeType?: (ticketTypeId: number) => void;
}

interface Signature {
  Args: Args;
}

export default class TicketTypeRow extends Component<Signature> {
  @service declare session: Session;
  @service declare inboxSidebarService: InboxSidebarService;

  get shouldShowTicketTypeDropdown(): boolean {
    if (this.inboxSidebarService.isPreviewingLinkedItem) {
      return false;
    }
    if (!this.session.teammate.permissions.canChangeTicketType) {
      return false;
    }
    return this.session.workspace?.isFeatureEnabled('hsg-inbox-change-ticket-type') ?? false;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::TicketAttribute::TicketTypeRow': typeof TicketTypeRow;
    'inbox2/ticket-attribute/ticket-type-row': typeof TicketTypeRow;
  }
}
